const storageKey = (shiftId: number) => `patrol-vehicle-start:${shiftId}`;

export type PatrolStartSnapshot = {
  company_vehicle_id: number;
  odometer_miles: number | null;
  vehicle_label: string;
};

export function savePatrolStartSnapshot(shiftId: number, snapshot: PatrolStartSnapshot): void {
  try {
    sessionStorage.setItem(storageKey(shiftId), JSON.stringify(snapshot));
  } catch {
    // ignore
  }
}

export function readPatrolStartSnapshot(shiftId: number): PatrolStartSnapshot | null {
  try {
    const raw = sessionStorage.getItem(storageKey(shiftId));
    if (!raw) return null;
    const p = JSON.parse(raw) as PatrolStartSnapshot;
    if (typeof p?.company_vehicle_id !== "number") return null;
    return {
      company_vehicle_id: p.company_vehicle_id,
      odometer_miles: p.odometer_miles ?? null,
      vehicle_label: typeof p.vehicle_label === "string" ? p.vehicle_label : "Vehicle",
    };
  } catch {
    return null;
  }
}

export function clearPatrolStartSnapshot(shiftId: number): void {
  try {
    sessionStorage.removeItem(storageKey(shiftId));
  } catch {
    // ignore
  }
}
